import { createContext, useContext } from 'react';

type DisplayPreferencesContextValue = {
  prefersMonospaceLiterals: boolean;
  setPrefersMonospaceLiterals: (next: boolean) => void;
};

export const DisplayPreferencesContext = createContext<DisplayPreferencesContextValue | null>(null);

export const useDisplayPreferences = (): DisplayPreferencesContextValue =>
  useContext(DisplayPreferencesContext) ?? {
    prefersMonospaceLiterals: false,
    setPrefersMonospaceLiterals: () => undefined,
  };
